import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/ui/tooltip'
import { InfoIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Anchor, Paragraph, Title } from 'src/components'
import CustomButton from 'src/components/Shared/UIComponents/Button'
import { clearStorageCache } from 'src/storage'

export default function Success() {
  const navigate = useNavigate()

  return (
    <div className="grid gap-x-12 gap-y-6 md:grid-cols-[auto_240px] sm:grid-cols-[auto_240px] items-center mb-10">
      <Title label="Success" className="col-span-full" />

      <Paragraph className="leading-8 col-span-full">
        You've successfully logged in to <b>Mobile Connect</b>. You can now
        finalize the setup procedure by setting up your identity management
        preferences.
      </Paragraph>
      <Paragraph className="leading-8 col-span-full">
        During the setup of your Amazon Connect instance, you were asked how you
        want to manage your users in Amazon Connect. Depending on that choice
        and how users currently log in to your Amazon Connect instance, please
        select one of the setup options below. More info can be found{' '}
        <Anchor
          target="_blank"
          href="https://docs.aws.amazon.com/connect/latest/adminguide/connect-identity-management.html"
        >
          here.
        </Anchor>
      </Paragraph>

      <img
        className=" col-span-full"
        src={require('src/images/identity_management.png')}
        width="600"
        alt="Identity Management"
      />

      <div className="text-secondary">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className="flex items-center gap-2">
              If the users are managed inside Amazon Connect
              <InfoIcon size={18} />
            </TooltipTrigger>
            <TooltipContent>
              <Paragraph className="col-span-1">
                Your Amazon Connect users are managed within Amazon Connect.
                Users can login using a user name and password for that is
                specific to Amazon Connect.
              </Paragraph>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <div className="md:justify-self-end">
        <CustomButton
          type="button"
          label="start CCP setup"
          onClick={() => {
            navigate('../../setup-ccp/arn')
            clearStorageCache('ONBOARDING')
          }}
        />
      </div>

      <div className="text-secondary">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className="flex items-center gap-2">
              If the users are managed by an existing directory (SSO)
              <InfoIcon size={18} />
            </TooltipTrigger>
            <TooltipContent>
              <Paragraph className="col-span-1">
                Your Amazon Connect users are linked to an existing directory.
                Users can login using their corporate credentials. Supported SSO
                providers: <b>Azure Active Directory</b>,{' '}
                <b>AWS IAM identity center</b>, <b>Google Workspace</b> and{' '}
                <b>Okta</b>.
              </Paragraph>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <div className="md:justify-self-end">
        <CustomButton
          type="button"
          label="start SSO setup"
          onClick={() => {
            navigate('../../setup-sso/arn')
            clearStorageCache('ONBOARDING')
          }}
        />
      </div>

      <div className="text-secondary">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className="flex items-center gap-2">
              If the users are managed by Salesforce
              <InfoIcon size={18} />
            </TooltipTrigger>
            <TooltipContent>
              <Paragraph className="col-span-1">
                Your Amazon Connect users are linked Salesforce. Users can login
                using their Salesforce credentials.
              </Paragraph>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <div className="md:justify-self-end">
        <CustomButton
          type="button"
          label="start Salesforce setup"
          onClick={() => {
            navigate('../../setup-salesforce/arn')
            clearStorageCache('ONBOARDING')
          }}
        />
      </div>

      <Paragraph className="col-span-full">
        If you require a custom setup or your identity provider is not listed,
        please contact us at{' '}
        <Anchor href="mailto:mc.notifications@idealsystems.be">
          mc.notifications@idealsystems.be
        </Anchor>
      </Paragraph>
    </div>
  )
}
